import { Hidden } from '@material-ui/core';
import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { getDateRange } from '../../../../../global/helpers/date-helpers';
import { ArcRoutes } from '../../../constants/routes';
import { Position, PositionTypes } from '../employment-model';


interface Props {
    position: Position;
    editText: string;
    editDisabled: boolean;
    isStip: boolean;
    presentDateText: string;
    dateLabel: string;
    positionTitleLabel: string;
}

export function PositionView(props: Props) {
    const { position, editText, isStip, presentDateText, editDisabled } = props;
    const routeMatch = useRouteMatch();
    const editPath = `${routeMatch.path}${ArcRoutes.Position}`;

    // leaving comment here in case there are business rules for stip vs non-stip
    const linkDisabled = editDisabled /*|| isStip*/;

    return (
        <div className='position-table-row'>
            <div className='position-table-cell position-table-cell-date'>

                <Hidden smUp>
                    <p className='input-label'>{props.dateLabel}</p>
                </Hidden>

                <p>{getDateRange(position.start_date, position.end_date, presentDateText)}</p>
            </div>
            <div className='position-table-cell position-table-cell-title'>
                <div className='position-table-cell-title-value '>
                    <Hidden smUp>
                        <p className='input-label'>{props.positionTitleLabel}</p>
                    </Hidden>
                    <p>{position.position_title}</p>
                    {
                        !linkDisabled &&
                        <Link
                            to={{
                                pathname: editPath,
                                state: {
                                    positionType: isStip ? PositionTypes.Stipendiary : PositionTypes.NonStipendiary,
                                    positionId: position.id,
                                },
                            }}
                            className={linkDisabled ? 'disabled' : ''}>
                            {editText}
                        </Link>
                    }

                </div>
            </div>
        </div>
    );
}